export default __webpack_public_path__ + "static/media/hst-logo.2bbbea4b.png";